/**
 * @Author: v_huangyongxing@baidu.com
 * @Date: 2023-03-20 17:35:26
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-06-09 16:27:12
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageSecureSmartLock.js
 * @Description: 物联网安全智能锁解决方案
 */

import React from 'react';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import './pageSecureSmartLock.less';

const structureData = [
    {
        imgSrc: require('../../asset/image/pageSecureSmartLock/minsu.png'),
        title: '酒店/公寓/民宿',
        text1: '-人证合一安全入住，入住记录实时上传，远程授权方便快捷。',
        text2: '-智能无源电子锁、智能指纹密码钥匙、智能读卡器、手机App与智能锁具管理平台互联。'
    },
    {
        imgSrc: require('../../asset/image/pageSecureSmartLock/xiaoyuan.png'),
        title: '社区/园区/校园',
        text1: '-数据云端一体化，实时上传记录，可远程快捷授权，并进行数据跟踪和分析，提供预警信息，帮助客户完成巡检、权限等管理操作。',
        text2: '-包含无源锁管理平台和手机App，基于SaaS架构提供锁具管理、安装空间管理、巡检任务设置、权限管理、部门管理、开锁记录查看等功能。',
    },
    {
        imgSrc: require('../../asset/image/pageSecureSmartLock/shangye.png'),
        title: '银行/商业综合体',
        text1: '-百度数字证书PKI CA人证系统，符合国密算法。',
        text2: '-连同可独立部署的物联网安全套件，保障智能锁安全。',
    }
];

const proinfoData = [
    {
        imgSrc: require('../../asset/image/pageBrain/icon_jishuzhicheng.svg'),
        title: '智能锁安全受到重视',
        text: '国家越来越重视智能锁信息安全，包括锁体安全、信息传输安全、通讯安全、平台安全等，对于平台、智能锁、App的信息安全将建立新的标准。'
    },
    {
        imgSrc: require('../../asset/image/pageBrain/icon_yewuzhuanjia.svg'),
        title: '与平台连接成基础',
        text: '场景应用与智能锁的深度融合成为智能锁销售的关键，与平台连接成为基础。'
    },
    {
        imgSrc: require('../../asset/image/pageBrain/icon_fengfu.svg'),
        title: 'B端市场规模增长',
        text: '智能锁市场需求增长加快，更多场景通过应用智能锁解决场景的管理和安全问题。'
    },
    {
        imgSrc: require('../../asset/image/pageBrain/icon_zhuanye.svg'),
        title: '技术革新体验至上',
        text: 'NB-IoT因其低功耗、免布线、通讯安全等特点，越来越受市场青睐，二维码、人脸识别、蓝牙、智能手环等新型开锁方式开始被广泛应用。',
    }
];


const PageCommercialPassword = props => {
    const bannerInfo = props.bannerInfo || {};

    return (
        <div className={'product Brain'}>
            <div className="pro-banner-box bg-new">
                <ProBanner
                    title={bannerInfo.title}
                    urlText={bannerInfo.urlText}
                    bgImg={bannerInfo.bgImg}
                    url={bannerInfo.url}
                />
                {bannerInfo.nextText ? (
                    <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                        {bannerInfo.nextText}
                    </a>
                ) : null}
            </div>

            <div className={'product-des'}>
                {bannerInfo.bannerNote}
            </div>

            <div className={'product-mod mt100'}>
                <ProductTitle title={'行业趋势'} />
            </div>

            <div className={'product-mod sec-p-box'}>
                {
                    proinfoData.map(({imgSrc, title, text}, index) => {
                        return <div className={'proinfo-box mui-flex'} key={index}>
                            <div className={'proinfo-box-icon'}>
                                <img
                                    src={imgSrc}
                                    width={'100%'}
                                />
                            </div>
                            <div className={'cell'}>
                                <div className={'proinfo-box-title'}>{title}</div>
                                <div className={'proinfo-box-des'}>
                                    {text}
                                </div>
                            </div>
                        </div>;
                    })
                }
            </div>

            <div className={'product-mod'}>
                <ProductTitle title={'业务挑战'} />
            </div>

            <div className={'product-mod'}>
                {
                    [
                        {
                            title: '存在潜在风险隐患',
                            content: '存在钥匙丢失、钥匙被复制等风险，且钥匙丢失或损坏后更换锁具成本较大。在一些规模较大的机构内，网店主管需要'
                                + '保管不同设备的大量锁具和钥匙，存在普遍的管理不规范、随意开锁的现象。'
                        },
                        {
                            title: '管理成本较大',
                            content: '由于管理人员变动，必须按相应规章制度的管理要求交接；由于备用钥匙集中管理，工作人员频繁流动导致备用钥匙保管员'
                                + '随时要变更保管记录，工作压力较大，备用钥匙管理使用混乱。'
                        },
                        {
                            title: '交接及保管存在混岗风险',
                            content: '由于部分双人分管的钥匙不能兼管，存在一定的混岗现象，也会带来不必要的风险。管理密码和钥匙的岗位人员不能混岗，'
                                + '必须平行交接，然而在实际工作中，无法实现平行交接且不方便。'
                        },
                        {
                            title: '密码管理漏洞多',
                            content: '目前银行加配钞的工作人员普遍年龄偏大，为方便起见，负责管理记录密码的人员不会经常修改初始密码，在输入密码期间'
                                + '也无法做到安全遮挡，存在密码盗用的风险；另外密码转盘属电子产品，灵敏度极高，不方便操作。'
                        }
                    ].map((item, index) => {
                        return <div className={'profun-box mui-flex'} key={index}>
                            <div className={'profun-box-icon'}>
                                <div className={'star'}>
                                </div>
                            </div>
                            <div className={'cell'}>
                                <div className={'profun-box-title'}>{item.title}</div>
                                <div
                                    className={'profun-box-des'}>
                                    {item.content}
                                </div>
                            </div>
                        </div>;
                    })
                }
            </div>

            <div className={'product-mod'}>
                <ProductTitle title={'方案架构'} />
            </div>

            <div>
                <img src={require('../../asset/image/pageSecureSmartLock/fanganjiagou.png')} alt="" width={'100%'} />
            </div>

            <div style={{background: '#F5F5F5', paddingBottom: '1rem'}}>
                <div className={'product-mod'} style={{paddingTop: '1rem'}}>
                    <ProductTitle title="方案介绍" />
                </div>
                <div>
                    {
                        [
                            {
                                title: '终端安全',
                                content: '内置安全芯片；锁体可信启动；数据安全存储；升级可信校验；固件加固防逆'
                            },
                            {
                                title: '平台安全',
                                content: '安全实施监控；合规等保三级；国密密钥体系；多重安全防护；端云闭环安全'
                            },
                            {
                                title: '身份安全',
                                content: '端云身份认证；端端离线认证；权限分级管理；入住人证比对；数据授权管理'
                            },
                            {
                                title: '云端安全',
                                content: '杜绝重放攻击；交互基于标识；防护篡改伪造；数据密态交互；轻量适配窄带'
                            }
                        ].map((item, index) => {
                            return (
                                <div key={index} className="saas-app-solution-card">
                                    <div className="title">{item.title}</div>
                                    <div className="content">{item.content}</div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>

            <div className={'product-mod mt100'}>
                <ProductTitle title={'应用场景'} />
            </div>

            <div>
                {
                    structureData.map(({imgSrc, title, text1, text2, imgWidth}, index) => {
                        return <div className={(index + 1) % 2 === 0 ? 'structure hui' : 'structure'} key={index}>
                            <div
                                className={'shadow'}
                            >
                                <div className={'imgBor'} style={{width: imgWidth ? imgWidth : '100%'}}>
                                    <img
                                        src={imgSrc}
                                        alt={title}
                                    />
                                </div>
                            </div>
                            <div className={'title'}>
                                {title}
                            </div>
                            <div className={'text'}>
                                {text1}
                            </div>
                            <div className={'text'}>
                                {text2}
                            </div>
                        </div>;
                    })
                }
            </div>

            <div className="saas-app-solution-contact">
                <div className="saas-app-solution-contact-inner">
                    <div className="des" style={{paddingTop: '1.2rem'}}>
                        联系我们立即获取免费技术专家咨询
                    </div>
                    <a href={bannerInfo.url} className="btn" style={{marginTop: '.76rem'}}>
                        立即咨询
                    </a>
                </div>
            </div>
        </div>
    );

};

PageCommercialPassword.propTypes = {
    bannerInfo: PropTypes.object
};

export default PageCommercialPassword;



// WEBPACK FOOTER //
// ./src/containers/product/pageSecureSmartLock.js